import { useAppSelector } from '@hooks/generic';
import { DashboardNavbar } from '@navbar/components/DashboardNavbar';
import { UserNavbar } from '@navbar/components/UserNavbar';
import { selectTitle } from '@store/appSlice';
import { createContext, PropsWithChildren, ReactElement, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

const DashboardLayoutScrollContext = createContext<HTMLDivElement | null>(null);

export const useDashboardLayoutScrollElement = () => useContext(DashboardLayoutScrollContext);

const DashboardLayout = ({
    children,
    customHeader,
    outlet,
}: PropsWithChildren<{ customHeader?: ReactElement; outlet?: boolean }>) => {
    const title = useAppSelector(selectTitle);
    const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);

    return (
        <DashboardLayoutScrollContext.Provider value={scrollElement}>
            <div className="flex h-screen overflow-hidden">
                <DashboardNavbar />
                <div className="flex min-w-0 flex-1 flex-col bg-gray-100">
                    {customHeader ? customHeader : title && <UserNavbar />}
                    <div ref={setScrollElement} className="min-h-0 flex-1 overflow-auto">
                        <div className="p-8 max-w-[1440px] w-full mx-auto">{outlet ? <Outlet /> : children}</div>
                    </div>
                </div>
            </div>
        </DashboardLayoutScrollContext.Provider>
    );
};

export { DashboardLayout };
